module.exports = __webpack_public_path__ + "static/media/launch.296884e8.png";